// sms template
export const SET_LOADING_SMS_TEMPLATE = 'SET_LOADING_SMS_TEMPLATE'
export const SET_SMS_TEMPLATE_PARAMS = 'SET_SMS_TEMPLATE_PARAMS'
export const SET_TEMPLATE_SMS_LIST = 'SET_TEMPLATE_SMS_LIST'

// message push
export const SET_MESSAGE_PUSH_PARAMS = 'SET_MESSAGE_PUSH_PARAMS'
export const SET_MESSAGE_LIST_INFO = 'SET_MESSAGE_LIST_INFO'
export const SET_MESSAGE_LIST_LOADING = 'SET_MESSAGE_LIST_LOADING'
